import { setting } from './core/setting';

export const printConsoleError = (method: string, input: any) => {
  if (setting.errorLog) console.info(`Error from ${method}\n${input}`);
};
